import { useContext } from 'react';
import { IThemeContext, ThemeContext } from 'context';

const useTheme = (): IThemeContext => useContext(ThemeContext);

export default useTheme;
